import { render, staticRenderFns } from "./AboutCounterItems.vue?vue&type=template&id=0fd452f1&"
import script from "./AboutCounterItems.vue?vue&type=script&lang=js&"
export * from "./AboutCounterItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports